export { GlobalAnalyticsContext } from './lib/global-context.service';
export * from './lib/analytics.module';
export * from './lib/analytics-base';
export * from './lib/analytics-global';
export * from './lib/analytics.directive';
export * from './lib/analytics-context';

// remove after moving the relevant components to the libraries
export * from './lib/shared/team-members.analytics';
export * from './lib/shared/notifications.analytics';
export * from './lib/shared/profile.analytics';
export * from './lib/shared/tags.analytics';
export * from './lib/shared/events.analytics';
export * from './lib/shared/calendar.analytics';
export * from './lib/shared/guides.analytics';
export * from './lib/shared/quick-evaluations.analytics';

export { AnalyticsSegmentClient } from './lib/analytics-segment-client';
export {
  AnalyticsTrackingDataService,
  AnalyticsTrackingData,
} from './lib/analytics-tracking-data.service';
